import { useEffect, useRef, useState } from "react";

export function usePrompt() {
  const [prompt, setPrompt] = useState("");
  const [previousPrompt, setPreviousPrompt] = useState<string | null>(null);
  const hasInitializedPromptFromSearch = useRef(false);

  // Initialize prompt from query params
  useEffect(() => {
    if (
      hasInitializedPromptFromSearch.current ||
      typeof window === "undefined"
    ) {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    const promptParam = params.get("prompt");

    if (!promptParam) {
      hasInitializedPromptFromSearch.current = true;
      return;
    }

    const normalizedPrompt = promptParam.replace(/\+/g, " ").trim();

    if (!normalizedPrompt) {
      hasInitializedPromptFromSearch.current = true;
      return;
    }

    hasInitializedPromptFromSearch.current = true;
    setPrompt(normalizedPrompt);
    setPreviousPrompt(normalizedPrompt);
  }, []);

  return {
    prompt,
    setPrompt,
    previousPrompt,
    setPreviousPrompt,
  };
}
